import { render } from "./Smash.vue?vue&type=template&id=39e3530a&scoped=true"
import script from "./Smash.vue?vue&type=script&lang=js"
export * from "./Smash.vue?vue&type=script&lang=js"

import "./Smash.vue?vue&type=style&index=0&id=39e3530a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e3530a"]])

export default __exports__